import { NgModule } from '@angular/core';
import { type Routes, RouterModule } from '@angular/router';
import {
  IsAuthenticatedGuard,
  IsNotAuthenticatedGuard,
} from '@principle-theorem/ng-auth';
import { IsNotAuthorisedGuard } from '@principle-theorem/ng-principle-shared';
import { AppAccountActionsComponent } from './app-account-actions/app-account-actions.component';
import { AuthPageComponent } from './auth-page/auth-page.component';
import { AuthPagesModule } from './auth-pages.module';
import { OAuthConsentComponent } from './oauth-consent/oauth-consent.component';
import { RegisterPageComponent } from './register-page/register-page.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { UserActivateComponent } from './user-activate/user-activate.component';
import { UserRestrictedComponent } from './user-restricted/user-restricted.component';
import { WorkspacesComponent } from './workspaces/workspaces.component';

const routes: Routes = [
  {
    path: 'login',
    data: { title: 'Login' },
    component: AuthPageComponent,
  },
  {
    path: 'register',
    data: { title: 'Register' },
    component: RegisterPageComponent,
  },
  {
    path: 'workspaces',
    canActivate: [IsAuthenticatedGuard],
    data: { title: 'Select a Workspace' },
    component: WorkspacesComponent,
  },
  {
    path: 'sign-up',
    data: { title: 'Sign Up' },
    canActivate: [IsNotAuthenticatedGuard],
    component: SignUpComponent,
  },
  {
    path: 'activate',
    data: { title: 'Activate' },
    canActivate: [IsNotAuthenticatedGuard],
    component: UserActivateComponent,
  },
  {
    path: 'unauthorised',
    canActivate: [IsAuthenticatedGuard, IsNotAuthorisedGuard],
    loadComponent: () =>
      import('./unauthorised/unauthorised.component').then(
        (mod) => mod.UnauthorisedComponent
      ),
  },
  {
    path: 'user-restricted',
    canActivate: [IsAuthenticatedGuard],
    component: UserRestrictedComponent,
  },
  {
    path: 'account-action',
    component: AppAccountActionsComponent,
  },
  {
    path: 'oauth/authorize',
    redirectTo: 'oauth/authorise',
    pathMatch: 'full',
  },
  {
    path: 'oauth/authorise',
    canActivate: [IsAuthenticatedGuard],
    component: OAuthConsentComponent,
  },
  {
    path: 'multifactor/enrol',
    canActivate: [IsAuthenticatedGuard],
    data: { title: 'Set Up Two-Factor Authentication' },
    loadComponent: () =>
      import('./multifactor-enrol-page/multifactor-enrol-page.component').then(
        (mod) => mod.MultifactorEnrolPageComponent
      ),
  },
  {
    path: 'multifactor/verify',
    data: { title: 'Two-Factor Authentication' },
    loadComponent: () =>
      import(
        './multifactor-verify-page/multifactor-verify-page.component'
      ).then((mod) => mod.MultifactorVerifyPageComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), AuthPagesModule],
  exports: [RouterModule],
})
export class AuthPagesRoutingModule {}
